import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    title: {
      marginBottom: '20px',
    },

    blockVersion: {
      width: '100%',
      height: '80px',
      borderRadius: '10px',
      background: '#EEF0F2',
      display: 'flex',
      padding: '8px',
    },
    blockVersionLogo: {
      width: '64px',
      height: '64px',
      background: '#2B398E',
      borderRadius: '10px',
      padding: '6px',
      overflow: 'hidden',
      position: 'relative',


    },
    dialog: {
      textAlign: 'left',
      direction: 'ltr',
      padding: theme.spacing(2),
      lineHeight: 2,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    cancelButton: {
      marginLeft: '5px',
    },
    addButton: {
      [theme.breakpoints.up('md')]: {
        transform: 'translate(5px, 31px)',
      },
    },
    isLoading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '16px 0',
    },
    isError: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      margin: '16px 0',
    },

    subItem: {
      fontSize: '12px',
      display: 'flex',
      '&:first-child': {
        paddingTop: '9px',
        borderTop: '1px solid #ebebeb',
      }
    },
    iconStyle: {
      opacity: '0.4',
      width: '0.8em',
      height: '0.8em',
    },
    fonticon8: {
      margin: '0 4px',
      marginBottom: '4px',
      top: "-2px",
      position: 'relative',
    },
    headItem: {
      display: 'flex',
      justifyContent: 'space-between',
      fontWeight: '700',
      marginBottom: 8,
    },
    buttonProgress: {
      color: '#fff',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    blockDialog: {
      width: 549,
      '@media(max-width: 600px)': {
        width: 280,


      }
    },
    CollapseMain: {
      width: '100%',
      padding: ' 0',
      margin: '20px auto 0',

    },
    blockVersionText: {
      padding: '10px',
      '& h4': {

        fontSize: '14px',
        color: '#232323',
        marginBottom: '7px',
        '@media(max-width: 600px)': {

          fontSize: '12px',

        }
      },
      '& span': {
        color: '#94A0A6',

      }
    },
    dialogMain: {
      '& .MuiDialog-paper': {
        borderRadius: '10px',
        overflowY: 'inherit',
      },
      '& .MuiDialogContent-root': {
        overflowY: 'auto',
        '&::scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-moz-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-track': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar': {
          width: '0',
          minWidth: '0',
        },
        '&::-webkit-scrollbar-thumb': {
          width: '0',
          minWidth: '0',
        },
        '&.noneOverFlow': {
          overflowY: 'inherit',
        },
      },
      '& .MuiDialogActions-root': {
        justifyContent: 'flex-start',
        display: 'flex',
        flexDirection: 'row-reverse',
        padding: '20px',
        gap: '15px',
      },
      '& .MuiDialog-container': {
        width: '100vw',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
    },
  };
});
